const MySqlViewConfig = Symbol.for("drizzle:MySqlViewConfig");
export {
  MySqlViewConfig
};
//# sourceMappingURL=view-common.js.map